import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About_us from "./pages/About_us";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import ClientsCommunity from "./pages/ClientsCommunity";
import Service from "./services/Services"; // ← Add this import

function App() {
  return (
    <Router>
      <Routes>

        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About_us />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/clients-community" element={<ClientsCommunity />} />

        {/* Dynamic Single Service Page */}
        <Route path="/services/:serviceId" element={<Service />} />

      </Routes>
    </Router>
  );
}

export default App;
